import {
    PROBLEM_LISTS_FETCH,
	PROBLEM_LISTS_FETCH_SUCCESS,
    PROBLEM_LISTS_FETCH_RESET,
} from "./types";

export const problemListsFetch = payload => {
    return {
        type: PROBLEM_LISTS_FETCH,
        payload: payload
    };
};

export const problemListsFetchSuccess = payload => {
    return {
        type: PROBLEM_LISTS_FETCH_SUCCESS,
        payload: payload
    };
};

export const problemListsFetchReset = () => {
    return {
        type: PROBLEM_LISTS_FETCH_RESET
    };
};